import React from 'react';
import { Form } from 'react-bootstrap';
import styles from './FormLabel.module.scss';

type FormLabelProps = React.ComponentProps<typeof Form.Label> & {
  required?: boolean; // opcional para ativar o asterisco só quando necessário
};

const FormLabel: React.FC<FormLabelProps> = ({ children, required, ...props }) => (
  <Form.Label {...props} style={{ whiteSpace: 'pre-line' }}>
    {children}
    {required && <span className="text-danger"> *</span>}
  </Form.Label>
);

export default FormLabel;
